import useTranslation from 'next-translate/useTranslation';
import { FARM_ADVISORY_SUPPORT } from '@/constants/common';
import useTriggerEvents from '@/hooks/useTriggerEvents';
import CustomEventTypes from '@/utils/analytics/customEventTypes';
// import { trackCustomEvent } from '@/utils/analytics/googleAnalytics'
import { isArray } from '@/utils/helper';
import ButtonLabel, { VARIANT } from '../ButtonLabel';
import FarmerSupport from '../icons/FarmerSupport';
import HeadPhoneIcon from '../icons/HeadPhoneIcon';
interface Props {
  tags?: number[];
}
const FarmerAdvisory = ({
  tags
}: Props) => {
  const {
    t
  } = useTranslation('cropProblem');
  const {
    trackCustomEvent
  } = useTriggerEvents();
  const handleClick = () => {
    trackCustomEvent(CustomEventTypes.CALL_CUSTOMER_CARE, isArray(tags) ? JSON.stringify(tags) : undefined);
  };
  return <FarmerSupport text={t('call_customer_care')} data-sentry-element="FarmerSupport" data-sentry-component="FarmerAdvisory" data-sentry-source-file="FarmerAdvisory.tsx">
      <a className="flex items-center bg-primary-100 mt-3 px-4 py-2.5 rounded-lg w-fit text-white" href={`tel:${FARM_ADVISORY_SUPPORT}`} onClick={handleClick} data-testid="take_farm_advice">
        <HeadPhoneIcon className="fill-transparent mr-1 w-6 h-6" pathClassName="fill-white" data-sentry-element="HeadPhoneIcon" data-sentry-source-file="FarmerAdvisory.tsx" />
        <ButtonLabel variant={VARIANT.ONE} label={t('take_farm_advice')} className="font-nato-semibold" data-sentry-element="ButtonLabel" data-sentry-source-file="FarmerAdvisory.tsx" />
      </a>
    </FarmerSupport>;
};
export default FarmerAdvisory;